<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth'],
		data () {
			return {
				modal: {
					selector: 'modal-edit-accounts-' + new Date().getTime(),
				},

				payment_methods: null,
				statuses: null,

				item: null,
			}
		},
		methods: {
			open(item) {
				this.item = Object.assign({}, item)
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getPaymentMethos()
				this.getStatuses()
			},
			getPaymentMethos() {
				this.$http.get('admin/management/payment/methods')
				.then(response => {
					this.payment_methods = response.body
				})
			},
			getStatuses() {
				this.$http.get('admin/statuses')
				.then(response => {
					this.statuses = response.body
				})
			},
			validate() {
				var that = this
				return this.$validator.validateAll().then((result) => {
					if(result) {
						that.update()
					}
					return result
				})
			},
			update () {
				var btnUpdate = Ladda.create(this.$refs.btnUpdate)
				btnUpdate.start()
				this.$http.put('admin/management/collection/account/' + this.item.id, this.item)
				.then(response => {
					this.close()
					this.$emit('reload')
					btnUpdate.stop()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					console.log(response)
					btnUpdate.stop()
					this.$emit('reload')
					if(response.status == 409) {
						swal({
							title: response.body.title,
							text: response.body.text,
							type: response.body.type,
						})
					}
				})
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/accounts/views/Edit.vue